import type { Decoder } from 'io-ts/Decoder';
import { array, struct } from 'io-ts/Decoder';

import { EqualsType } from '../../api/generic/search/filter/EqualsType';

export const ListFilter = <V>(ValueType: Decoder<unknown, V>) =>
	struct({
		type: EqualsType,
		values: array(ValueType),
	});
